<template>
    <div
        class="bo-label-filter"
        ref="root"
    >
        <button
            ref="trigger"
            type="button"
            class="bo-label-filter__trigger search-input"
            :class="{ 'has-selection': value.length > 0 }"
            :aria-expanded="isOpen ? 'true' : 'false'"
            @click="toggleMenu"
        >
            <span class="bo-label-filter__summary">{{ summary }}</span>
            <i class="icon-expandmore"></i>
        </button>
        <div
            v-show="isOpen"
            ref="menu"
            class="bo-label-filter__menu"
            :style="menuStyle"
        >
            <label
                v-for="option in options"
                :key="option.id"
                class="bo-label-filter__option"
            >
                <input
                    type="checkbox"
                    :checked="value.includes(option.id)"
                    @change="toggle(option.id)"
                />
                <span>{{ option.text }}</span>
            </label>
        </div>
    </div>
</template>

<script>
// Header filter of the cart's Product Labels column: a multi-select list of checkboxes.
// v-model holds the selected label ids.
export default {
    props: {
        // [{id, text}]
        options: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isOpen: false,
            menuStyle: {},
        };
    },
    computed: {
        summary() {
            if (this.value.length === 0) {
                return window.bo?.generalTranslations?.search ?? "Search";
            }

            return this.options
                .filter((option) => this.value.includes(option.id))
                .map((option) => option.text)
                .join(", ");
        },
    },
    watch: {
        // Filtering re-lays out the table, which moves the trigger.
        value() {
            this.$nextTick(() => requestAnimationFrame(this.placeMenu));
        },
    },
    mounted() {
        // Lives in <body>: inside the sticky header cell, the next header row would paint over it.
        document.body.appendChild(this.$refs.menu);
        document.addEventListener("click", this.closeOnOutsideClick);
        window.addEventListener("scroll", this.placeMenu, true);
        window.addEventListener("resize", this.placeMenu);
    },
    beforeDestroy() {
        this.$refs.menu.remove();
        document.removeEventListener("click", this.closeOnOutsideClick);
        window.removeEventListener("scroll", this.placeMenu, true);
        window.removeEventListener("resize", this.placeMenu);
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
            this.placeMenu();
        },
        placeMenu() {
            if (!this.isOpen) {
                return;
            }

            const rect = this.$refs.trigger.getBoundingClientRect();
            this.menuStyle = {
                top: `${rect.bottom + 4}px`,
                left: `${rect.left}px`,
                minWidth: `${rect.width}px`,
            };
        },
        closeOnOutsideClick(event) {
            if (this.isOpen && !this.$refs.root.contains(event.target) && !this.$refs.menu.contains(event.target)) {
                this.isOpen = false;
            }
        },
        toggle(id) {
            const selected = this.value.includes(id) ? this.value.filter((value) => value !== id) : [...this.value, id];

            this.$emit("input", selected);
        },
    },
};
</script>
